export const zIndexes = {
    z1205: "1205px"
}